import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { loadLibraryList } from '../actions/library-list.actions';
import { getLibraryList, LibraryList, LibraryListState, LibraryListTypes } from '../reducers/library-list.reducer';

@Injectable()
export class LibraryListResolver implements Resolve<LibraryList> {
  constructor(
    private store: Store<LibraryListState>,
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot) {
    const listId = route.paramMap.get('listId');
    const showcaseId = route.paramMap.get('showcaseId');
    const libraryListType = listId ? LibraryListTypes.LIST : LibraryListTypes.SHOWCASE;

    this.store.dispatch(loadLibraryList({id: listId || showcaseId, libraryListType}));
    return this.store.pipe(select(getLibraryList))
    .pipe(
      filter(libraryList => !!libraryList),
      take(1)
    );
  }
}
